import moment from "moment-timezone";
import Panels from "@/enums/Panels";

const panelPropertiesMixin = {
	data() {
		return {
			panelLocationType: null,
			locationChangeDisposable: null,
		};
	},

	computed: {
		panelParams() {
			return this.params?.params ?? {};
		},

		liveMode() {
			return this.$store.getters.liveMode();
		},

		isPopout() {
			return this.panelLocationType === "popout";
		},

		overlayAttach() {
			if (this.isPopout) {
				try {
					const popoutWindow = this.params.api.getWindow();
					return popoutWindow?.document?.body || false;
				} catch {
					return false;
				}
			}
			return false;
		},

		overlayDefaults() {
			if (!this.overlayAttach) {
				return {};
			}
			const attach = this.overlayAttach;
			return {
				VMenu: {attach},
				VTooltip: {attach},
				VDialog: {attach},
			};
		},

		selectedStationID() {
			return this.liveMode ?
			       this.$store.getters.liveModeSelectedStationID() :
			       this.panelParams.selectedStationID ?? null;
		},

		selectedStation() {
			return this.$store.getters.getLoadedStationById(this.selectedStationID);
		},

		stationName() {
			return this.selectedStation?.StationName;
		},

		stationTimezone() {
			return this.selectedStation?.StationTimeZone ?? moment.tz.guess();
		},

		stationDateTime() {
			return moment.tz(this.stationTimezone);
		},

		stationCurrentHour() {
			return moment.tz(this.stationTimezone).startOf("hour");
		}
	},

	mounted() {
		const dockViewApi = this.params?.api;
		if (dockViewApi) {
			this.panelLocationType = dockViewApi.location?.type ?? "grid";
			// Subscribe to location change events so we can react whenever the panel moves
			// (e.g., when it is popped out into a new window or docked back)
			this.locationChangeDisposable = dockViewApi.onDidLocationChange((event) => {
				this.panelLocationType = event.location?.type ?? "grid";
			});
		}
	},

	beforeUnmount() {
		// clean up the location change listener (prevents memory leaks and weird updates after unmount)
		if (this.locationChangeDisposable) {
			this.locationChangeDisposable.dispose();
			this.locationChangeDisposable = null;
		}
	},

	watch: {
		stationName: {
			handler(stationName, previous) {
				if (!this.params) {
					return;
				}
				if (!stationName) {
					this.params.api.setTitle(Panels[this.panelParams.panelName].title);
				}
				else if (stationName !== previous) {
					this.params.api.setTitle(
						`${Panels[this.panelParams.panelName].title} - ${stationName}`
					);
				}
			},
			immediate: true
		}
	}
}

export default panelPropertiesMixin;
